export const countDecimals = (value: number): number => {
  if (isNaN(value)) {
    return 0;
  }

  if (Math.floor(value.valueOf()) === value.valueOf()) {
    return 0;
  }

  var str = value.toString();
  if (str.indexOf(".") !== -1 && str.indexOf("-") !== -1) {
    return Number(str.split("-")[1] || 0);
  } else if (str.indexOf(".") !== -1) {
    return str.split(".")[1].length || 0;
  }

  return Number(str.split("-")[1] || 0);
};

export interface CompilerError {
  type: CompilerErrorType;
  message: string;
  attribute?: string | null;
}

export type Uuid = `${string}-${string}-${string}-${string}-${string}`;
const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
export const isUuid = (v: string): v is Uuid => {
  if (typeof v !== "string") {
    return false;
  }
  return Boolean(v.match(UUID_REGEX));
}

export const escapeRegExp = (string: string): string => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
};
import type { CompilerErrorType } from "./CompilerErrorType";
